import Swiper, { EffectCreative, Keyboard, SwiperOptions, Pagination, Navigation } from "swiper";
export const zeroPad = (num: number, places: number) => String(num).padStart(places, '0')


const heroSliders = document.querySelectorAll<HTMLElement>(".g-hero-slider")

heroSliders.forEach(slider => {
  const fractionCurrent = slider.closest(".s-hero-slider")?.querySelector(".swiper-fraction__current")
  const fractionTotal = slider.closest(".s-hero-slider")?.querySelector(".swiper-fraction__total")

  const swiperSettings: SwiperOptions = {
    modules: [Keyboard, EffectCreative, Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 8,
    keyboard: {
      enabled: true,
    },
    pagination: {
      el: slider.closest(".s-hero-slider")?.querySelector<HTMLElement>(".swiper-progress"),
      type: "progressbar",
    },
    navigation: {
      nextEl: slider.closest(".s-hero-slider")?.querySelector<HTMLElement>(".swiper-button-next"),
      prevEl: slider.closest(".s-hero-slider")?.querySelector<HTMLElement>(".swiper-button-prev"),
    },
    effect: 'creative',
    creativeEffect: {
      prev: {
        translate: [0, 0, -400],
        opacity: 0,
      },
      next: {
        translate: ['calc(100% + 8px)', 0, 0],
      },
    },
    on: {
      init: (swiper) => {
        slider.classList.remove("--loading")
        if (fractionTotal) { fractionTotal.innerHTML = zeroPad(swiper.slides.length, 2) }
        if (fractionCurrent) { fractionCurrent.innerHTML = zeroPad(swiper.realIndex + 1, 2) }
      },
      activeIndexChange: (swiper) => {
        if (fractionCurrent) { fractionCurrent.innerHTML = zeroPad(swiper.realIndex + 1, 2) }
      }
    }
  }

  new Swiper(slider, swiperSettings)

})
